var e=!!(typeof window<"u"&&window.document&&window.document.createElement),o=e;export{o as default};
//# sourceMappingURL=isBrowser.js.map
